var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-20"},[_c('base-header'),_c('router-view',{staticClass:"flex-grow"}),_c('base-footer',{class:{ 'pb-14': _vm.hasStickyFooter }}),_c('shortlist-modal'),_c('search-modal'),_c('book-detail-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }